<template>
  <div v-if="waitForLoad">
    <div v-if="!purchaseOrder.enteredInPtrac" class="row" style="justify-content:left; align-items:center;">
      <router-link :to="'/admin/supply-pro/'">
        <button class="btn btn-md btn-fill btn-info" style="margin-right:20px;"><span style="font-size:x-large;">&larr;</span></button>
      </router-link>
      <h4><strong>Purchase Order #: {{ purchaseOrder.header.builderOrderNumber}}</strong> from <i>{{ purchaseOrder.header.builder.name }}</i></h4>
      <project @scrollToJob="scrollToJob" :id="purchaseOrderId" ref="project"></project>
      <job @scrollToJob="scrollToJob" style="margin-top: 15px" ref="job"></job>
    </div>
    <div v-else>
      Purchase Order #{{ purchaseOrder.header.builderOrderNuber }} has already been entered into PTRAC
      <br>
      <router-link :to="'/admin/supply-pro/'">
        <button class="btn btn-md btn-fill btn-info" style="margin-right:20px;">Go Back</button>
      </router-link>
    </div>
  </div>
</template>
<script>
import project from './Project'
import job from './Job'
import {mapGetters} from 'vuex'
import Constants from '@/utilities/constants'

export default {
  computed: {
    ...mapGetters({
      purchaseOrder: 'supplyPro/purchaseOrder/purchaseOrder'
    }),
    waitForLoad() {
      if (this.purchaseOrder) {
        // console.log("Purchase order on mount?", this.$store.get('supplyPro/purchaseOrder/purchaseOrder'))
        if (Object.keys(this.purchaseOrder).length !== 0) {
          return true
        }
      }
    }
  },
  components: {
    project,
    job
  },
  props: ['purchaseOrderId'],
  methods: {
    scrollToJob(){
      // Need timeout because it takes 0.5s for project to collapse and Job to take its final position
      setTimeout(() => {this.$refs["job"].$el.scrollIntoView({ behavior: "smooth" })}, Constants.TIME.MILLIS.HALF_SECOND)
    }
  },
  async created() {
    await this.$store.cache.dispatch('types/fetchByEntityType', 'Project')
    await this.$store.dispatch('supplyPro/purchaseOrder/fetchPurchaseOrder', this.purchaseOrderId)
  },
  beforeDestroy() {
    this.$store.commit('supplyPro/project/reset')
    this.$store.commit('supplyPro/job/reset')
    this.$store.commit('supplyPro/purchaseOrder/reset')
  }
}
</script>
